import React from 'react';

export default function ClimbersDealPrivacy() {
  const styles = {
    page: {
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      fontFamily: 'Times, "Times New Roman", serif',
      color: '#000000',
      margin: 0,
      padding: 0,
    },
    container: {
      maxWidth: '8.5in',
      margin: '0 auto',
      padding: '1in',
      lineHeight: '1.5',
      fontSize: '12pt',
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      borderBottom: '2px solid #000',
      paddingBottom: '20px',
    },
    title: {
      fontSize: '18pt',
      fontWeight: 'bold',
      margin: '0 0 10px 0',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    subtitle: {
      fontSize: '14pt',
      fontWeight: 'normal',
      margin: '0',
      fontStyle: 'italic',
    },
    section: {
      marginBottom: '25px',
      pageBreakInside: 'avoid',
    },
    sectionNumber: {
      fontSize: '14pt',
      fontWeight: 'bold',
      marginBottom: '10px',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },
    paragraph: {
      fontSize: '12pt',
      marginBottom: '12px',
      textAlign: 'justify',
      textIndent: '0.5in',
      lineHeight: '1.5',
    },
    list: {
      paddingLeft: '0.75in',
      marginBottom: '12px',
    },
    listItem: {
      fontSize: '12pt',
      marginBottom: '6px',
      listStyleType: 'disc',
    },
    footer: {
      marginTop: '40px',
      paddingTop: '20px',
      borderTop: '1px solid #000',
      textAlign: 'center',
      fontSize: '10pt',
      color: '#666',
    },
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Privacy Policy</h1>
          <p style={styles.subtitle}>Climbers Deal Application</p>
        </div>

        <div style={styles.section}>
          <p style={styles.paragraph}>
            Climbers Deal ("we", "our", "us") respects your privacy. We only
            collect what's necessary to run core features of the app (price
            alerts, crash reporting, and delivering content).
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>1. Data Sharing</h2>
          <p style={styles.paragraph}>
            We do not sell or share your data except as required by law or to
            provide core functionality.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>2. Information We Collect</h2>
          <p style={styles.paragraph}>
            The following information may be collected during the normal
            operation of our application:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Push Notification Token</li>
            <li style={styles.listItem}>Follow/Unfollow Data</li>
            <li style={styles.listItem}>App Crash Reports</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>
            3. How and Why We Use This Information
          </h2>
          <p style={styles.paragraph}>
            The information collected is used solely for the following purposes:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>Provide core functionality</li>
            <li style={styles.listItem}>
              Maintain app reliability (crash and performance reports)
            </li>
            <li style={styles.listItem}>Improve user experience</li>
          </ul>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>4. Data Retention & Security</h2>
          <p style={styles.paragraph}>
            Information is retained only as long as necessary and is
            automatically deleted after use. We take reasonable measures to
            protect your data against unauthorized access.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>5. Your Choices</h2>
          <p style={styles.paragraph}>
            You can turn off notifications in system settings or unfollow
            products in the app.
          </p>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionNumber}>6. Policy Changes</h2>
          <p style={styles.paragraph}>
            We may update this policy for legal or product reasons in the future
            if needed.
          </p>
        </div>

        <div style={styles.footer}>
          <p>Document effective as of the date of last revision.</p>
        </div>
      </div>
    </div>
  );
}
